/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCostcoProduct200ResponseAllOfData } from './GetCostcoProduct200ResponseAllOfData';
import {
    GetCostcoProduct200ResponseAllOfDataFromJSON,
    GetCostcoProduct200ResponseAllOfDataFromJSONTyped,
    GetCostcoProduct200ResponseAllOfDataToJSON,
} from './GetCostcoProduct200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetCostcoProduct200Response
 */
export interface GetCostcoProduct200Response {
    /**
     * 
     * @type {GetCostcoProduct200ResponseAllOfData}
     * @memberof GetCostcoProduct200Response
     */
    data: GetCostcoProduct200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetCostcoProduct200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetCostcoProduct200Response interface.
 */
export function instanceOfGetCostcoProduct200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetCostcoProduct200ResponseFromJSON(json: any): GetCostcoProduct200Response {
    return GetCostcoProduct200ResponseFromJSONTyped(json, false);
}

export function GetCostcoProduct200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCostcoProduct200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCostcoProduct200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetCostcoProduct200ResponseToJSON(value?: GetCostcoProduct200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCostcoProduct200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

